<template>
  <div class="container pi-feedback-details">
    <div class="container-flex">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=" "
        @load="onLoad"
        :immediate-check="false"
        class="list-container"
        ref="vanList"
      >
        <ul class="feedback-details-list">
          <li
            class="feedback-item"
            :class="item.sourceType == 0 ? 'left' : 'right'"
            v-for="(item, index) in list"
            :key="index + '-1'"
          >
            <div class="time">{{ item.createTime }}</div>
            <div class="user-img-box">
              <img
                class="user-img"
                v-if="item.sourceType == 0"
                :src="headImgUrl"
                alt=""
              />
              <img
                class="user-img"
                v-else
                src="../../assets/image/customer-service.png"
                alt=""
              />
            </div>
            <div class="feedback-flex">
              <div class="name-box">
                <div class="name" v-if="item.sourceType == 0">
                  {{ item.sourceTypeName }}
                </div>

                <div class="name" v-if="item.sourceType == 1">
                  {{ item.sourceTypeName }}
                </div>
              </div>
              <div class="content">
                <div class="triangle-left"></div>
                {{ item.content }}
              </div>
            </div>
            <ul
              class="feedback-ul"
              v-if="item.picturesParamList && item.picturesParamList.length > 0"
            >
              <li
                class="feedback-img"
                v-for="(child, index) in item.picturesParamList"
                :key="index"
                @click="queryImg(item.filePath, item.picturesParamList)"
              >
                <img :src="$config.fileUrl + child.thumbnailFilePath" alt="" />
              </li>
            </ul>
          </li>
        </ul>
      </van-list>
    </div>
    <div class="go-feedback">
      <pi-button type="primary" block @click="gotoFeedback">回复消息</pi-button>
    </div>
  </div>
</template>

<script>
import { getFeedDetails } from "../../common/api/index";
import wxJsSdk from "@/common/location";
import { List } from "vant";
import { mapState } from "vuex";
export default {
  name: "pi-feedback-list",
  components: {
    [List.name]: List,
  },
  data() {
    return {
      data: {},
      list: [],
      form: {
        feedbackPkId: "",
        globalPageIndex: 1,
        globalPageSize: 10,
      },
      total: 0,
      loading: false,
      finished: false,
      headImgUrl: "",
    };
  },
  computed: {
    ...mapState(["app"]),
  },
  mounted() {
    console.log(this.app);
    console.log(this.app.userInfo);
    this.headImgUrl =
      this.app.userInfo && this.app.userInfo.headImgUrl
        ? this.app.userInfo.headImgUrl
        : "";
    this.form.feedbackPkId = this.$route.query.feedbackPkId;
    this.getFeedDetails();
  },
  methods: {
    queryImg(url, picturesParamList) {
      let urls = [];
      let origin = window.location.origin;
      picturesParamList.map((item) => {
        urls.push(origin + this.$config.fileUrl + item.filePath);
      });
      let current = origin + this.$config.fileUrl + url;

      if (process.env.NODE_ENV == "production") {
        wxJsSdk.previewImage(
          current, // 当前显示图片的http链接
          urls // 需要预览的图片http链接列表
        );
      }
    },
    onLoad() {
      this.form.globalPageIndex++;
      this.getFeedDetails();
    },
    async getFeedDetails() {
      let ret = await getFeedDetails(this.form);
      if (ret.status === this.$config.ajaxStatus) {
        this.list.push(...ret.data);
        this.total = ret.total;
        if (this.list.length >= this.total) {
          this.finished = true;
        }
      } else {
        this.finished = true;
      }
    },
    gotoFeedback() {
      this.$router.push("/feedback?feedbackPkId=" + this.form.feedbackPkId);
    },
  },
};
</script>

<style lang="less">
.pi-feedback-details {
  .container-flex {
    background-color: #f5f5f5;
  }
  .feedback-details-list {
    padding: 0.2rem;
    .feedback-item {
      position: relative;
      margin-top: 0.4rem;
      .user-img-box {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 0.1rem;
        background-color: #fff;
        position: absolute;
        top: 0.4rem;
        overflow: hidden;
        .user-img {
          width: 100%;
          height: 100%;
        }
      }
      .feedback-flex {
        .name-box {
          line-height: 0.36rem;
          .name {
            font-size: 0.28rem;
            color: #333;
            display: inline-block;
          }
        }
        .content {
          background-color: #fff;
          border-radius: 0.1rem;
          padding: 0.2rem;
          display: inline-block;
          margin-top: 0.1rem;
          position: relative;
        }
      }
      .time {
        font-size: 0.24rem;
        color: #999;
        text-align: center;
        margin-bottom: 0.1rem;
      }
    }
    .feedback-item.left {
      .user-img-box {
        left: 0;
      }
      .feedback-flex {
        padding-left: 1rem;
        // .time{
        //     margin-left: 0.3rem;
        // }
      }
      .triangle-left {
        position: absolute;
        left: -0.15rem;
        top: 10%;
        width: 0;
        height: 0;
        border-top: 0.1rem solid transparent;
        border-right: 0.2rem solid #fff;
        border-bottom: 0.1rem solid transparent;
      }
    }
    .feedback-item.right {
      text-align: right;
      .user-img-box {
        right: 0;
      }
      .feedback-flex {
        padding-right: 1rem;
        // .time{
        //     margin-right: 0.3rem;
        // }
      }
      .triangle-left {
        position: absolute;
        right: -0.15rem;
        top: 10%;
        width: 0;
        height: 0;
        border-top: 0.1rem solid transparent;
        border-left: 0.2rem solid #fff;
        border-bottom: 0.1rem solid transparent;
      }
    }
    .feedback-ul {
      margin-top: 0.4rem;
      padding-left: 0.8rem;
      display: flex;
      flex-wrap: wrap;
      .feedback-img {
        width: 1.6rem;
        height: 1.6rem;
        margin-left: 0.2rem;
        margin-bottom: 0.2rem;
        background-color: #e5e5e5;
        border-radius: 0.1rem;
        img {
          width: 100%;
          height: 100%;
          border-radius: 0.1rem;
          pointer-events: auto;
        }
      }
    }
  }
  .go-feedback {
    padding: 0.2rem;
  }
  //
  // .title{
  //   font-size: 0.32rem;
  //   line-height: 0.4rem;
  // }
  // .time{
  //   margin-top: 0.1rem;
  //   color: #999;
  // }
  // .content{
  //   margin-top: 0.4rem;
  //   font-size: 0.24rem;
  // }
  // .feedback-ul{
  //   margin-top: 0.6rem;
  //   display: flex;
  //   flex-wrap: wrap;
  //   margin-left: -0.2rem;
  //   .feedback-img{
  //     width: 1.6rem;
  //     height: 1.6rem;
  //     margin-left: 0.2rem;
  //     margin-bottom: 0.2rem;
  //     background-color: #e5e5e5;
  //     border-radius: 0.1rem;
  //     img{
  //       width: 100%;
  //       height: 100%;
  //       border-radius: 0.1rem;
  //       pointer-events: auto;
  //     }
  //   }
  // }
  // .kf-content{
  //   margin-top: 0.6rem;
  // }
  // .wait-kf{
  //   margin-top: 0.6rem;
  //   font-size: 0.32rem;
  //   color: #14CC80;
  // }
}
</style>
